export default __webpack_public_path__ + "static/media/img1.c3cc3277.png";